import React, { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

import { useUserContext } from '../../../common/utils/context';
import { Screen } from '../../design/components';
import { MY_DAY_MODE } from '../myDay/useMyDayMode';
import { ServiceRunListView } from '../servicerun';
import { useDriverShell } from './DriverDayProvider';
import { DRIVER_ROUTE } from './driverRoutes';
import MyRunsView from './MyRunsView';

// Drivers get history and previews; other roles retain the existing run list.
const AllRunsView = () => {
	const navigation = useNavigation();
	const { mode, refetchModeData, selectRun } = useDriverShell();
	const { isDriver } = useUserContext();
	const isPickerMode = mode === MY_DAY_MODE.PICKER;

	const openRun = useCallback((run) => {
		if (!selectRun(run?.id)) {
			return false;
		}

		navigation.navigate(DRIVER_ROUTE.RUN_LIST);
		return true;
	}, [navigation, selectRun]);

	if (isDriver && !isPickerMode) {
		return <MyRunsView />;
	}

	return (
		<Screen
			backLabel="Home"
			heading="All Runs"
			subheading={isDriver && !isPickerMode ? undefined : 'Every service run, including runs not assigned to you.'}
			scroll={false}
		>
			<ServiceRunListView refetchModeData={refetchModeData} showEveryRun={isPickerMode} onRunPress={openRun} />
		</Screen>
	);
};

export default AllRunsView;
